<template>
    <div
        ref="root"
        class="
            flex
            items-center
            gap-4
            bg-gray-100
            py-2
            px-4
            rounded-lg
            relative
        "
        v-bind="$attrs"
        @click="selectRef.click()"
    >
        <div v-if="prefix">
            {{ prefix }}
        </div>
        <div>{{ localLabel }}</div>
        <ion-icon
            name="chevron-down-outline"
            class="text-xl ml-auto"
        ></ion-icon>
        <select
            @change="tryAutosubmit"
            ref="selectRef"
            class="opacity-0 absolute top-0 left-0 w-full h-full"
            :name="name"
            v-model="localValue"
        >
            <option
                v-for="option in options"
                :value="option.value"
                :key="option.value"
            >
                {{ option.label }}
            </option>
        </select>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";

const selectRef = ref(null);
const props = defineProps({
    name: String,
    options: Array,
    prefix: String,
    modelValue: String,
    autosubmit: Boolean,
});

const localLabel = computed(() => {
    console.log({ a: props.options });
    const selected = props.options.find(
        (option) => option.value === props.modelValue
    );
    return selected ? selected.label : null;
});

const localValue = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit("update:modelValue", value);
    },
});

const emit = defineEmits(["update:modelValue"]);

function tryAutosubmit() {
    if (props.autosubmit && selectRef.value.form) {
        selectRef.value.form.submit();
    } else {
        // emit("update:modelValue", selectRef.value.value);
    }
}
</script>

<style scoped></style>
